import React from 'react';
const Profile = () => {
  return <div className="py-4" data-id="element-945">
      <div className="mb-6" data-id="element-946">
        <h1 className="text-2xl font-semibold text-gray-800" data-id="element-947">Profile</h1>
        <p className="text-gray-600" data-id="element-948">Manage your account settings</p>
      </div>
      <div className="bg-white rounded-md shadow-sm p-6" data-id="element-949">
        <p className="text-gray-500" data-id="element-950">Profile settings coming soon...</p>
      </div>
    </div>;
};
export default Profile;